module.exports = __webpack_public_path__ + "static/img/expo.37361772.png";